<template>
  <div id="index">
    <el-container>
      <el-header height="105px" :class="{'is-hidden': !isShowHeader }">
        <common-header></common-header>
      </el-header>
      <el-main>
        <!-- 轮播图 -->
        <carousel></carousel>
        <!-- 导航路由内容 -->
        <router-view></router-view>
      </el-main>
      <el-footer height="200px">
        <div class="footer">
          <div class="beianhao">
            <div style="display:flex;justify-content: center;align-items: center;">
              <div>
                版权所有：
                北京易伟航科技有限公司&nbsp;&nbsp;&nbsp;|
                <a class="linkCss" href="https://beian.miit.gov.cn" target="_blank">&nbsp;&nbsp;&nbsp;京ICP备09010697号-1</a>
              </div>
              <i class="icon_jb"></i>
              <div>
                <a target="_blank" class="linkCss"
                  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802030299">
                  <p style="margin: 0px 0px 0px 5px;">
                    京公网安备 11010802030299号
                  </p>
                </a>
              </div>
            </div>
            <div style="padding-top:15px">
              邮编:100085 | 电话: (010)82784097 | E-mail:
              market@evialab.com | 通讯地址:
              北京市海淀区上地四街一号院5号楼213室
            </div>
          </div>
        </div>
      </el-footer>
    </el-container>
    <el-backtop target="#index" :bottom="60" :right="60"></el-backtop>
  </div>
</template>

<script>
const carousel = () => import("./carousel/carousel.vue");
const commonHeader = () => import("./header/commonHeader.vue");
export default {
  name: "index",
  components: { carousel, commonHeader },
  data() {
    return {
      isShowHeader:true,
      lastScrollTop: 0,
    };
  },
  methods: {
    init() {
      this.$router.push("/");
    },
    handleScroll(e) {
      // 获取滚动条滚动的距离
      // const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const scrollTop = e.target.scrollTop;
      // 判断是否需要隐藏 sticky
      if (scrollTop > this.lastScrollTop) {
        this.isShowHeader = false;
      } else {
        this.isShowHeader = true;
      }
      this.lastScrollTop = scrollTop;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true);
    this.init();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
#index {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  line-height: 30px;
}

.el-header {
  position: fixed;
  top: 0px;
  z-index: 10000;
  width: 100%;
  background-color: #fff;
  transition: transform 0.3s ease-in-out;
}
.is-hidden {
  transform: translateY(-100%);
}
.el-main {
  margin-top: 105px;
}
.el-backtop {
  z-index: 10000;
}
.icon {
  width: 185px;
  height: 66px;
  padding-right: 100px;
  background: url("../assets/index/logo.png") no-repeat;
}

.el-header,
.el-main,
.el-footer {
  padding: 0;
}

.footer {
  height: 100%;
  width: 100%;
  background-color: #012a56;

  .beianhao {
    position: relative;
    top: 72px;
    color: #fff;
    font-size: 14px;

    .linkCss {
      text-decoration: none;
      color: #fff;
    }

    .icon_jb {
      display: inline-block;
      height: 18px;
      width: 16px;
      margin-left: 10px;
      background: url("../assets/login/jinghui.png") no-repeat;
    }
  }
}
</style>
<style lang="scss">
.main {
  width: 1200px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);

  // 一级标题
  .title_1 {
    font-size: 30px;
    font-weight: 600;
    color: #333;
    margin-top: 80px;
  }

  // 二级标题
  .title_2 {
    font-size: 20px;
    font-weight: 600;
    color: #333;
  }

  // 文本
  .text {
    line-height: 35px;
    font-size: 18px;
    color: #333;
  }

  .text_sol {
    padding: 30px;
    text-align: left;
  }

  .img_1 {
    width: 50%;
    height: 50%;
  }

  .flex {
    padding-top: 60px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .flex_1 {
    display: flex;
    justify-content: center;
    padding-bottom: 30px;
  }

  .flex_2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 40px;
  }

  .flex_3,
  .flex_4 {
    display: flex;
    height: 42px;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    // font-size: 12px;
    font-weight: 600;
  }

  .flex_3 {
    width: 100%;
    height: 100%;
    padding: 80px 0;
  }

  .div_1,
  .div_2,
  .div_3,
  .div_4 {
    .divImg {
      padding-right: 10px;
    }
  }

  .div_1 {
    flex: 25%;

    .divImg {
      height: 80%;
      width: 40px;
    }
  }

  .div_2 {
    flex: 21%;

    .divImg {
      height: 80%;
      width: 70px;
    }
  }

  .div_3 {
    flex: 32%;

    .divImg {
      height: 80%;
      width: 70px;
    }
  }

  .div_4 {
    flex: 22%;

    .divImg {
      height: 80%;
      width: 40px;
    }
  }

  .flex_4 {
    text-align: center;
    justify-content: flex-start;
    padding: 5px 0;

    img {
      height: 100%;
    }
  }

  .div {
    width: 25%;
  }

  .hzImg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    padding: 80px 0;
  }

  .newsCss {
    text-align: left;
    padding: 40px;
  }

  .btn {
    width: 140px;
    height: 50px;
    font-size: 20px;
    margin-top: 40px;
    margin-bottom: 80px;
  }

  .el-button.is-round {
    border-radius: 30px;
  }
}

.splitLine {
  height: 1px;
  position: relative;
  margin: 20px 0;
  width: 100%;
  background-color: #dcdfe6;
}

.yLine {
  height: 20px;
  width: 6px;
  margin-right: 10px;
  background: url("../assets/index/yLine.png");
}

.line {
  display: inherit;
  position: relative;
  top: -2px;
  left: 50%;
  transform: translateX(-50%);
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAACCAIAAACVJxhLAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ4IDc5LjE2NDAzNiwgMjAxOS8wOC8xMy0wMTowNjo1NyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIxLjAgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjQ1RkRGRDdCOEQ2OTExRUNCOUJFOTE3NzE0QzdGNTIxIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjQ1RkRGRDdDOEQ2OTExRUNCOUJFOTE3NzE0QzdGNTIxIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NDVGREZENzk4RDY5MTFFQ0I5QkU5MTc3MTRDN0Y1MjEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NDVGREZEN0E4RDY5MTFFQ0I5QkU5MTc3MTRDN0Y1MjEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4ACOFKAAAAFklEQVR42mJk8FvEMPgAE8OgBAABBgAcNwD0rebhVwAAAABJRU5ErkJggg==);
  height: 3px;
  width: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue